import React from 'react';
import { AlertCircleIcon, CheckCircle2Icon, ClockIcon, RepeatIcon, SearchIcon, ShieldIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
const costs = [[ClockIcon, '120 horas de tu vida por año', '3 horas de planificación × 40 semanas. Tiempo que recuperás desde hoy con los 6 tomos y las clases ya armadas.'], [AlertCircleIcon, 'Clases de cinta siempre iguales', 'Sin progresiones de aparatos repetís los mismos ejercicios: las alumnas se aburren y el avance técnico se detiene.'], [RepeatIcon, 'El mismo caos del año anterior', 'Sin planificador anual el año arranca improvisado, sin objetivos por trimestre ni evaluación que muestre el progreso.'], [SearchIcon, 'El mismo ciclo, el próximo año', 'Domingo buscando en Google, lunes con material que “más o menos sirve”. Y en doce meses, otra vez desde cero.']] as const;
export function GuaranteeAndCost() {
  return <>
      <section className="border-y border-line bg-surface px-4 py-12 md:py-16" data-id="element-133" data-mp="3ogrj8a0oylrc">
        <div className="mx-auto max-w-3xl text-center" data-id="element-134" data-mp="3shbipk8qm1gn">
          <span aria-hidden="true" className="inline-flex rounded-full border-2 border-gold bg-gold/10 p-5" data-id="element-135" data-mp="1ah22e1juoeg">
            <ShieldIcon className="h-10 w-10 text-gold" data-id="element-136" data-mp="62ibls7c210s" />
          </span>
          <div className="mt-5" data-id="element-137" data-mp="b0tl21tpu9ih">
            <Eyebrow data-id="element-138" data-mp="azqvpyc1kf4o">🛡️ Garantía 7 días — sin preguntas</Eyebrow>
          </div>
          <SectionTitle data-id="element-139" data-mp="fxse0h1n8af3">
            Probalo 7 días. Si no te sirve,{' '}
            <span className="text-gold" data-id="element-140" data-mp="k06uiuhuay37">te devolvemos el 100%.</span>
          </SectionTitle>
          <div className="mt-7 rounded-2xl border border-line bg-ink p-6 text-left font-medium leading-relaxed text-zinc-300 md:p-8" data-id="element-141" data-mp="p0bg2yxluj0a">
            <p data-id="element-142" data-mp="2ltd5oxqido6q">
              Abrís los tomos. <b className="text-white" data-id="element-143" data-mp="2lug0hgqycarx">Los usás en tus clases con tus alumnas.</b>
            </p>
            <p className="mt-3" data-id="element-144" data-mp="2qszm1g1mvkjr">
              Y si en 7 días no es lo que esperabas, escribís a compradigitalyaa@gmail.com y te
              devolvemos el 100% del dinero.
            </p>
            <div className="mt-4 flex flex-wrap gap-4 text-sm font-bold text-white" data-id="element-145" data-mp="3p527htb2axlw">
              {['Sin formularios', 'Sin esperas', 'Sin drama'].map(text => <span key={text} className="flex items-center gap-1.5" data-id="element-146" data-mp="1xi01ubb6wcx">
                  <CheckCircle2Icon aria-hidden="true" className="h-5 w-5 text-gold" data-id="element-147" data-mp="gv0jch57whcz" />
                  {text}
                </span>)}
            </div>
          </div>
          <p className="mt-6 text-lg font-bold text-white" data-id="element-148" data-mp="pnucnihi1h9u">
            El riesgo no es tuyo. <span className="text-gold" data-id="element-149" data-mp="pporcf26gd5h">Es nuestro.</span>
          </p>
          <div className="mt-6 grid grid-cols-3 gap-3 text-center" data-id="element-150" data-mp="lmsdf1nl157v">
            <Metric value="<1%" label="Tasa de devoluciones" data-id="element-151" data-mp="zl8m2y5095sn" />
            <Metric value="+500" label="Profesoras que ya lo usan" data-id="element-152" data-mp="zjp6l9r6ayrx" />
            <Metric value="7 días" label="Garantía sin condiciones" data-id="element-153" data-mp="uoi2i0tzrs2h" />
          </div>
        </div>
      </section>

      <section className="px-4 py-12 md:py-16" data-id="element-154" data-mp="1e6nqmjnpaqwm">
        <div className="mx-auto max-w-4xl" data-id="element-155" data-mp="1j83fkmt01hka">
          <Eyebrow danger data-id="element-156" data-mp="1j5qyscyz9d8t">⚖️ El costo real</Eyebrow>
          <SectionTitle data-id="element-157" data-mp="14bcca2g7flpe">
            ¿Cuánto te cuesta <span className="text-red-400" data-id="element-158" data-mp="14aawxls5od1v">NO tenerlo?</span>
          </SectionTitle>
          <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-159" data-mp="1982scps0ehat">
            {costs.map(([CostIcon, label, cost]) => <li key={label} className="flex gap-3 rounded-xl border border-line bg-surface p-4" data-id="element-160" data-mp="vg62ksdtcjhl">
                <span aria-hidden="true" className="h-fit rounded-lg border border-red-500/30 bg-red-500/10 p-2" data-id="element-161" data-mp="10b26apsewvaj">
                  <CostIcon className="h-5 w-5 text-red-400" data-id="element-162" data-mp="qjxsvuidxiht" />
                </span>
                <p data-id="element-163" data-mp="cj4vn20p89b0">
                  <b className="block text-sm text-white" data-id="element-164" data-mp="ckof11hnj0h0">{label}</b>
                  <span className="text-sm font-medium text-zinc-400" data-id="element-165" data-mp="gli2xuv3gf9w">{cost}</span>
                </p>
              </li>)}
          </ul>
          <p className="mt-10 rounded-2xl border border-gold/25 bg-surface p-6 text-center text-lg font-bold text-zinc-200 md:text-2xl" data-id="element-166" data-mp="9h0h57eeitay">
            El domingo puede volver a empezar el mismo ciclo.
            <br data-id="element-167" data-mp="3vvjpamcs9c8z" />
            <span className="text-gold" data-id="element-168" data-mp="3vv0c1iy2vc1a">O el próximo domingo puede ser diferente. 🎀</span>
          </p>
          <div className="mt-8 text-center" data-id="element-169" data-mp="3mwoknepe0a7s">
            <Button href="#pricing" className="w-full text-sm md:w-auto md:text-base" data-id="element-170" data-mp="3mxg63wp9srkc">
              Empezar hoy con Gimnasia Rítmica PRO →
            </Button>
          </div>
        </div>
      </section>
    </>;
}
function Metric({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="rounded-xl border border-line bg-ink p-3" data-id="element-171" data-mp="380h02da2h6rz">
      <p className="text-xl font-black text-gold" data-id="element-172" data-mp="1b6vommoe6t28">{value}</p>
      <p className="mt-1 text-[10px] font-bold leading-tight text-zinc-400" data-id="element-173" data-mp="1b6ch7zwdbn2g">{label}</p>
    </div>;
}